<nav class="megamenu-nav" [class.scrolled]="isScrolled">
  <div class="nav-container">
    <!-- Logo -->
    <div class="nav-logo" (click)="navigateTo('/')">
      <img src="/assets/CombLogo.svg" alt="Complete Pest Control" class="logo-icon">
      <span class="logo-text">{{ config.name }}</span>
    </div>

    <!-- Desktop Navigation -->
    <div class="nav-menu desktop-menu">
      <div 
        *ngFor="let item of menuItems" 
        class="nav-item dropdown-container"
        (mouseenter)="item.megamenu ? showDropdown(item.key) : null"
        (mouseleave)="hideDropdown()"
      >
        <button 
          class="nav-link"
          [class.active]="activeDropdown === item.key"
          (mouseenter)="showDropdown(item.key)"
          (mouseleave)="hideDropdown()"
        >
          {{ item.title }}
          <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
        </button>

        <!-- Megamenu Dropdown -->
        <div 
          *ngIf="item.megamenu && activeDropdown === item.key" 
          class="megamenu-dropdown"
          (mouseenter)="showDropdown(item.key)"
          (mouseleave)="hideDropdown()"
        >
          <div class="megamenu-content">
            <div 
              *ngFor="let section of item.megamenu.sections" 
              class="megamenu-section"
            >
              <h4 class="section-title">{{ section.title }}</h4>
              <ul class="section-items">
                <li *ngFor="let subItem of section.items">
                  <a (click)="navigateTo(subItem.route)" class="section-link">
                    {{ subItem.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side Actions -->
    <div class="nav-actions">
      <button class="phone-btn" mat-button (click)="callPhone()">
        <mat-icon>phone</mat-icon>
        <span class="phone-number">{{ config.phone.display }}</span>
      </button>
      <button class="quote-btn" mat-raised-button (click)="navigateTo('/contact')">
        Get Your Free Quote
      </button>
      <button class="login-btn" mat-button (click)="navigateToLogin()">
        <mat-icon>login</mat-icon>
        Login
      </button>
    </div>

    <!-- Mobile Menu Toggle -->
    <button 
      class="mobile-menu-toggle" 
      mat-icon-button 
      (click)="toggleMobileMenu()"
    >
      <mat-icon>{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>

  <!-- Mobile Menu -->
  <div class="mobile-menu" [class.open]="isMobileMenuOpen">
    <div class="mobile-menu-content">
      <div *ngFor="let item of menuItems" class="mobile-nav-item">
        <button 
          class="mobile-nav-link"
        >
          {{ item.title }}
        </button>
        
        <div *ngIf="item.megamenu" class="mobile-submenu">
          <div *ngFor="let section of item.megamenu.sections" class="mobile-section">
            <h5 class="mobile-section-title">{{ section.title }}</h5>
            <ul class="mobile-section-items">
              <li *ngFor="let subItem of section.items">
                <a (click)="navigateTo(subItem.route)" class="mobile-section-link">
                  {{ subItem.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div class="mobile-actions">
        <button class="mobile-phone-btn" mat-button (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          {{ config.phone.display }}
        </button>
        <button class="mobile-quote-btn" mat-raised-button (click)="navigateTo('/contact')">
          Get Free Quote
        </button>
      </div>
    </div>
  </div>
</nav>